<!-- @format -->

<div class="form-group">
  <h4 translate="PLAN_EDIT.INLINE_SEARCH_TITLE_MODULE"></h4>
  <p class="guidance guidance__inverted" translate="PLAN_EDIT.INLINE_SEARCH_GUIDANCE"></p>
  <sis-inline-search
    [searchTarget]="searchTarget"
    [id]="rule.localId"
    [parentModule]="parentModule"
    [validatablePlan]="validatablePlan"
    [curriculumPeriodIds]="curriculumPeriodIds"
    [codeUrns]="codeUrns"
    (selectResult)="onSelectModuleResultItem($event)"></sis-inline-search>
</div>
@if (codeUrns?.length > 0) {
  <sis-contextual-notification variant="light">{{
    "PLAN_EDIT.SEARCH_ONLY_FOR_MINORS_NOTIFICATION" | translate
  }}</sis-contextual-notification>
}
@for (module of selectedModules; track module) {
  <div>
    <sis-rule-module-box
      [module]="module"
      [planValidationResult]="planValidationResult"
      [planStateObject]="planStateObject"
      [planData]="planData">
      <div module-action class="additional-box">
        <sis-button class="button-box" [link]="true" (clicked)="unselectModule(module)" [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
          <sis-icon icon="delete"></sis-icon>
        </sis-button>
      </div>
    </sis-rule-module-box>
  </div>
}
@for (customModuleAttainment of selectedCustomModuleAttainments; track customModuleAttainment) {
  <div>
    <sis-rule-custom-module-attainment-box
      [customModuleAttainment]="customModuleAttainment"
      [planValidationResult]="planValidationResult"
      [planStateObject]="planStateObject"
      [planData]="planData">
      <div custom-module-attainment-action class="additional-box">
        <sis-button
          class="button-box"
          [link]="true"
          (clicked)="unselectCustomModuleAttainment(customModuleAttainment)"
          [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
          <sis-icon icon="delete"></sis-icon>
        </sis-button>
      </div>
    </sis-rule-custom-module-attainment-box>
  </div>
}
